<template>
  <div
    :class="[commonStore.getupDatingToast.showToast ? 'l-modal__bg' : '']"
  ></div>

  <!-- お気に入り案件 -->
  <div class="favorite">
    <div class="favorite-contents">
      <section
        class="favorite-contents-item-selection"
        v-on:scroll="handleScroll()"
      >
        <div v-for="(data, index) in displayList" :key="index">
          <ul class="product-img-wrap" @click="detail(data.id)">
            <div class="image-area">
              <img :src="data.image" />
              <div>
                <p class="project-title">{{ data.title }}</p>
              </div>
            </div>
          </ul>
        </div>
        <div
          :style="hiddenLoading()"
          v-show="loading"
          :class="[
            displayList && displayList.length > 0 ? 'loading' : 'first-loading',
          ]"
        >
          <img src="../assets/loading.gif" />
        </div>
      </section>

      <!-- </transition> -->
    </div>
    <div v-if="!loading && !displayList?.length" class="no-data">
      <img :src="NO_DATA.get(4).img" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { onMounted, ref } from "vue";
import { ProjectStore } from "../store/ProjectStore";
import { CommonStore } from "../store/CommonStore";
import { NO_DATA } from "../consts/common";

const projectStore = ProjectStore();

const loading = ref(true);
const commonStore = CommonStore();
const displayList = ref(projectStore.favoriteProjectList || []);

onMounted(async () => {
  if (!projectStore.favoriteProjectList.length) {
    await getProjectList();
  } else if (
    projectStore.favoriteProjectList.length &&
    !projectStore.favoriteAllCalled
  ) {
    projectStore.forceUpdateFavorite();
    loading.value = false;
  } else {
    displayList.value = projectStore.favoriteProjectList || [];
    getScrollHeight();
    loading.value = false;
  }
});
// スクロール位置の保持、無限スクロール
const handleScroll = async () => {
  const container = document.getElementsByClassName(
    "favorite-contents-item-selection"
  )[0] as HTMLElement;
  if (projectStore.favoriteAllCalled) return;

  setScrollHeight();
  if (loading.value) return;
  if (!container || !container.scrollHeight) return
  if (
    container.scrollHeight - (container.clientHeight + container.scrollTop) >
    120
  )
    return;

  loading.value = true;
  const initLoading = document.getElementsByClassName(
    "loading"
  )[0] as HTMLElement;
  initLoading.style.top =
    container.offsetTop + container.scrollHeight - 50 + "px";

  const pageNum = projectStore.favoritePageNum + 1;
  projectStore.setFavoritePageNum(pageNum);
  await projectStore.getFavoriteProjects();
  displayList.value = projectStore.favoriteProjectList || [];
  loading.value = false;
};
const setScrollHeight = () => {
  const item = document.getElementsByClassName(
    "favorite-contents-item-selection"
  )[0] as HTMLElement;
  if(!item || !item.scrollTop) return
  commonStore.setFavoriteScrollHeight(item.scrollTop);
};
const getScrollHeight = () => {
  displayList.value = projectStore.favoriteProjectList || [];
  const item = document.getElementsByClassName(
    "favorite-contents-item-selection"
  )[0] as HTMLElement;
  if (!item) return;
  item.scrollTo({
    top: commonStore.getFavoriteScrollHeight,
    behavior: "auto",
  });
};

const hiddenLoading = () => {
  if (!loading.value) {
    return "visibility: hidden;";
  } else {
    return "visibility: visible;";
  }
};

const getProjectList = async () => {
  loading.value = true;
  await projectStore.getFavoriteProjects().then(() => {
    displayList.value = projectStore.favoriteProjectList || [];
    loading.value = false;
  });
};

const router = useRouter();
document.title = "お気に入り";

// const store = ProjectStore();

const detail = (id: number) => {
  projectStore.setSelectedId(id);
  router.push("/project-detail");
};
</script>

<style scoped lang="scss">
@import "../assets/style/_variables.scss";
@import "../assets/style/mixin.scss";

.favorite {
  // width: 100%;
  // height: 100%;
  overflow-y: auto;
  height: 100%;
}
#header {
  position: sticky;
  top: 0;
}

.favorite-contents {
  width: 100%;
  height: calc(100% - 20px);
  display: flex;
}
.favorite-contents-item-selection {
  // height: calc(100% - 75px);
  top: 20px;
  overflow-y: auto;
  scrollbar-width: none;
  max-height: 100%;
  box-sizing: border-box;
  padding: 0px 10px 10px 10px;
  width: 100%;
  transition: all 0.8s ease;
}
.favorite-contents-item-selection::-webkit-scrollbar {
  display: none;
}

input {
  display: none;
  border-radius: 90px;
  color: $white;
}

.product-img-wrap {
  list-style: none;
  padding-left: 0;
  width: 100%;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  height: 130px;
  border-radius: 10px;
}
.image-area {
  display: flex;
  width: 100%;
  height: 100%;
  > img {
    min-width: 110px;
    min-height: 110px;
    object-fit: cover;
    margin: 10px 0 9px 9.5px;
    border-radius: 10px;
  }
  .project-title {
    margin: 10px 16px 0 14px;
    overflow-y: hidden;
    font-weight: 300;
    height: 43px;
    line-height: 21px;
    font-size: $FONT_SIZE_M;
    @include line-clamp(2);
    word-break: break-all;
  }
  .state {
    margin-left: 18.5px;
    margin-top: 10px;
    display: inline-block;
    height: 18px;
    background: rgba(0, 116, 255, 0.07);
    border-radius: 2px;
    font-style: normal;
    font-weight: 300;
    font-size: $FONT_SIZE_S;
    line-height: 18px;
    span {
      color: $OMOT_COLOR;
    }
  }
  .infinite-loading {
    position: fixed !important;
    // width: 87%;
    width: 100%;
    max-width: 480px;
    height: 15px;
    bottom: 80px;
  }
}
.loading {
  display: flex;
  position: relative;
  justify-content: center;
  img {
    width: 10%;
    height: 10%;
  }
}
.first-loading {
  display: flex;
  width: 96%;
  max-width: 460px;
  position: fixed;
  justify-content: center;
  top: 50%;
  img {
    width: 10%;
    height: 10%;
  }
}
.l-modal__bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  z-index: 99;
}
</style>
